export default __webpack_public_path__ + "media/color/qlc-c229661b.svg";